import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { ModeContextProvider } from '../../../../../../contexts';
import { AssessmentAccordion } from '../../../../../Assessment';
import {
  ARQualificationDetails,
  QualificationDetailMode,
} from '../../../../../AcademicRegistry/components';
import {
  PAGE_TEXT,
  documentRequiredInformation20240203,
  documentRequiredInformation2025010203,
} from '../lang';
import { studentStatusInformation } from './lang';

const { DOCUMENTS_REQUIRED_FOR_QUALIFICATION_CHECK } = PAGE_TEXT;

export type QualificationCheckStatusProps = {
  entryYear: string;
};

// !!! NOTICE!!!
// As display the result of each item, the release function of admin will lost efficacy
export const QualificationCheckStatus: React.FunctionComponent<
  QualificationCheckStatusProps
> = (props: QualificationCheckStatusProps) => {
  const { applicationId } = useParams();
  const { entryYear } = props;

  let documentRequiredInformation = '';
  if (['2024-02', '2024-03'].includes(entryYear)) {
    documentRequiredInformation = documentRequiredInformation20240203;
  } else if (['2025-01', '2025-02', '2025-03'].includes(entryYear)) {
    documentRequiredInformation = documentRequiredInformation2025010203;
  }

  return (
    <div>
      <InformationContainer>
        <AssessmentAccordion
          AssessDetails={
            <div
              className="p-4 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: documentRequiredInformation }}
            />
          }
          title={DOCUMENTS_REQUIRED_FOR_QUALIFICATION_CHECK}
        />
        <div
          className="p-4 leading-relaxed"
          dangerouslySetInnerHTML={{ __html: studentStatusInformation }}
        />
      </InformationContainer>
      <ModeContextProvider mode={QualificationDetailMode.APPLICANT_VIEW}>
        <ARQualificationDetails applicationId={applicationId} />
      </ModeContextProvider>
    </div>
  );
};

const InformationContainer = styled.div`
  p {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;

    padding-left: 0.5rem;
    padding-right: 0.5rem;

    text-align: justify;
  }

  ul {
    list-style: circle;
    margin-left: 2rem;
  }

  table,
  th,
  td {
    border: 2px solid #9ca3af;
  }

  .important-note {
    color: red;
    font-weight: bolder;
  }
`;
